export default {"src":"/_next/static/media/substance.7e7112ee.svg","height":17,"width":19,"blurWidth":0,"blurHeight":0};